import $ from 'jquery';

if (typeof window !== 'undefined') {
  window.custom$ = window.$ = window.jQuery = $;
}



//////////////////
// WEBPACK FOOTER
// ./vendor/jquery-shim.js
// module id = 2920
// module chunks = 3